import React from 'react';
import { Container, Group, Box, Image } from '@mantine/core';
import Logout from './Logout';
import AtomsLogo from "./../../assets/AtomsLogo.png"

import { Link } from 'react-router-dom';

const NarBarTopComponent = () =>
{
  // Use the org logo stored at login; fall back to Atoms logo
  const orgLogoUrl = localStorage.getItem('org_logo_url') || '';
  const logoSrc = orgLogoUrl || AtomsLogo;

  return (
    <Container size="lg">

      <div style={{ padding: '0.5rem', display: 'flex', alignItems: 'center' }}>
        <div id="navCompanyLogo" >
          <Group position='left'>
            <Link to={'/app/dashboard'} replace>
              <Image
                width={'5.5rem'}
                ml={56}
                mt={8}
                src={logoSrc}
                alt="Company Logo"
                fit="contain"
              />
            </Link>
          </Group>
        </div>
        <Group position='right' style={{ margin: '0', alignItems: 'center' }}>
          {/* <div style={{ display: 'flex', alignItems: 'center' }}> */}
          {/* <Input
            id="navtop_search"
            placeholder="Search..."
            rightSection={

              <AiOutlineSearch

                size="1rem"
                id="icon_search"
                style={{ opacity: 0.5, marginTop: '11px' }} />

            }
          /> */}
          {/* <Box mt={7} >
            <Notifications />
          </Box> */}
          <Box mt={7}>
            <Logout />
          </Box>
          {/* </div> */}
        </Group>
      </div>
    </Container>
  );
};

export default NarBarTopComponent;
